import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaSpotify, FaYoutube, FaMusic } from "react-icons/fa";

type Align = "left" | "center" | "right";

interface Slide {
  title: string;
  subtitle: string;
  align: Align;
  image: string; // <-- TAMBAH INI
}

const slides: Slide[] = [
  {
    title: "Kalia Siska",
    subtitle: "Suara Merdu, Energi Panggung Memukau",
    align: "left",
    image: "/images/feel.jpg",
  },
  {
    title: "Dangdut x Ska Reggae",
    subtitle: "Dangdut Koplo Modern Favorit Anak Muda",
    align: "center",
    image: "/images/img1.jpg",
  },
  {
    title: "Cover Viral YouTube",
    subtitle: "Hits Viral & Penampilan Berkelas",
    align: "right",
    image: "/images/kaliateam.png",
  },
];

const gradients = ["linear-gradient(135deg,#0f172acc 0%,#1e293bcc 40%,#0ea5e9cc 100%)", "linear-gradient(135deg,#1e1b4bcc 0%,#4c1d95cc 40%,#9333eacc 100%)"];

const Hero = () => {
  const [index, setIndex] = useState(0);
  const [animate, setAnimate] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate(false);

      setTimeout(() => {
        setIndex((prev) => (prev + 1) % slides.length);
        setAnimate(true);
      }, 300);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const slide = slides[index];

  const alignment: Record<Align, string> = {
    right: "justify-end text-right",
    left: "justify-start text-left",
    center: "justify-center text-center",
  };

  return (
    <section className="relative min-h-screen flex items-center text-white overflow-hidden">
      {/* BACKGROUND */}
      <div className="absolute inset-0">
        {slides.map((s, i) => (
          <div
            key={i}
            className={`absolute inset-0 bg-cover transition-all duration-1000 ${i === index ? "opacity-55 scale-100" : "opacity-0 scale-105"}`}
            style={{
              backgroundImage: `url(${s.image})`,
              backgroundPosition: "center top", // <-- INI PENTING
            }}
          />
        ))}
      </div>

      {/* GRADIENT */}
      <div
        className="absolute inset-0 transition-all duration-1000"
        style={{
          background: gradients[index % gradients.length],
        }}
      />

      {/* CONTENT */}
      <div className={`relative max-w-7xl mx-auto px-6 pt-24 pb-12 w-full flex ${alignment[slide.align]}`}>
        <div className={`max-w-xl transition-all duration-700 ${animate ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <p className="uppercase tracking-[0.35em] text-sm opacity-80">KALIA SISKA OFFICIAL</p>

          <h1 className="text-5xl md:text-7xl font-bold mt-4 leading-tight">{slide.title}</h1>

          <p className="mt-6 text-lg text-white/90">{slide.subtitle}</p>

          {/* BUTTON */}
          <Link to="/explore">
            <button className="mt-8 bg-white text-black font-semibold px-7 py-3 rounded-lg hover:bg-gray-200 transition">Explore Music</button>
          </Link>
        </div>
      </div>

      {/* INDICATOR */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex gap-3">
        {slides.map((_, i) => (
          <div key={i} className={`h-[4px] w-16 rounded-full transition-all duration-500 ${i === index ? "bg-white" : "bg-white/40"}`} />
        ))}
      </div>
    </section>
  );
};

export default Hero;
